import { useRecommendationTags } from "@features/recommender/hooks/useRecommendationTags";
import { useLookup } from "@rentablo/api/apiv1";
import { FundRecommendationResponse } from "@rentablo/api/recommender";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material";
import { buildChartData } from "@components/Chart/HorizontalBarChart";

export const usePerformanceTagsData = (
  recommendation: FundRecommendationResponse
) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { tags } = useRecommendationTags(recommendation);

  const { data: lookupData } = useLookup(
    {
      tickerSymbol: recommendation?.fund.ticker!,
      quoteProvider: "ariva",
      includeIndexes: false,
      interval: "year",
      intervalPosition: "current",
      inPercentFrom: "currentToNow",
    },
    { enabled: Boolean(recommendation) }
  );

  if (!recommendation) return undefined;

  const data = lookupData?.historicQuotes?.[recommendation.fund.ticker!] ?? [];
  const chartData = buildChartData(
    t,
    theme.palette.success.light,
    theme.palette.error.light,
    data
  );

  const displayHorizontalBarChart = Boolean(chartData?.length);

  return {
    infoTags: tags,
    data: chartData,
    displayHorizontalBarChart,
  };
};
